import {ComponentFactory} from "components/componentFactory";
import {Component, ComponentDefinition, ParentComponent} from "components/components/Component";
import {isPostRenderedComponent} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import $ from "jquery";
import template from "./tab.hbs";

export class Tab extends InputBaseComponent<TabDefinition> implements ParentComponent {
    public componentType = "tab";
    public children: Component[] = [];

    constructor(schema: TabDefinition) {
        super(schema);
    }

    public render(): Element {
        this.view = $(template(this.definition))[0];
        return this.view;
    }

    public appendChildView(childView: Node): void {
        $(childView).appendTo($(this.view).find(".c-tab__children:first") as JQuery<HTMLElement>);
    }

    public postRender() {
        for (let child of this.children) {
            if (isPostRenderedComponent(child)) {
                child.postRender();
            }
        }
    }
    public setValidationStatus(valid: boolean, message?: string) {
        // TODO This is wrong
    }
}

export interface TabDefinition extends ComponentDefinition {
    titleKey: string;
    children: ComponentDefinition[];
}
